import NextImage from 'next/legacy/image'
import type { FunctionComponent } from 'react'
import { Translation } from '../../contexts/TranslationContext'
import style from './IconItem.module.sass'

type IconItemProps = {
	value: number | undefined
	title: string | undefined
	iconUrl: string | undefined
}

export const IconItem: FunctionComponent<IconItemProps> = ({ iconUrl, title, value }) => {
	return (
		<div className={style.wrapper}>
			{iconUrl && (
				<div className={style.iconWrapper}>
					<NextImage src={iconUrl} alt={title ?? ''} title={title} layout="fill" objectFit="contain" />
				</div>
			)}
			<span className={style.title}>{title}</span>
			{value ? (
				<div className={style.value}>
					{String(value).replace('.', ',')} <Translation tr="iconItem.unit" />
				</div>
			) : (
				<div className={style.valueEmpty}>
					<Translation tr="iconItem.emptyValue" />
				</div>
			)}
		</div>
	)
}
